module.exports = __webpack_public_path__ + "static/media/illustration-agreement.be49c204.svg";